import(/* webpackMode: "eager", webpackExports: ["SRP","PDP"] */ "/workspace/libs/catalog-ui/src/lib/catalog-ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogContext","CatalogContextProvider","useCatalogContext"] */ "/workspace/libs/catalog-ui/src/lib/Contexts/CatalogContext.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/catalog-ui/src/lib/Hooks/useCiCSearch.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useProductLink"] */ "/workspace/libs/catalog-ui/src/lib/Hooks/useProductLink.ts");
;
import(/* webpackMode: "eager" */ "/workspace/libs/catalog-ui/src/lib/Modules/FeaturedProducts/FeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterPanel"] */ "/workspace/libs/catalog-ui/src/lib/Modules/Filters/FilterPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Paginator"] */ "/workspace/libs/catalog-ui/src/lib/Modules/Paginations/Paginator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SRPPaginator"] */ "/workspace/libs/catalog-ui/src/lib/Modules/Paginations/SRPPaginator.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/image-circle-xmark-regular-full.svg");
;
import(/* webpackMode: "eager", webpackExports: ["MarkFavourite"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/MarkFavourite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCard"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLink"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/ProductLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductTags"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/ProductTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Samples"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductCard/Samples.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DownloadLink"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/DownloadLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetails"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/ProductDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsClientSide"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/ProductDetailsClientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSpec"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/ProductSpec.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwatchZoom"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/SwatchZoom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VizLoaderBrokerInit"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/VizLoaderBrokerInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVisualizer"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductDetails/WebVisualizer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductResults"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductResults/ProductResults.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductResultsBanner"] */ "/workspace/libs/catalog-ui/src/lib/Modules/ProductResults/ProductResultsBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShopifyScript"] */ "/workspace/libs/catalog-ui/src/lib/ShopifyScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useShopifyScript"] */ "/workspace/libs/catalog-ui/src/lib/useShopifyScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientContextProvider"] */ "/workspace/libs/react-helpers/src/lib/contexts/ClientContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FavouriteProductsContext","FavouriteProductsContextProvider"] */ "/workspace/libs/react-helpers/src/lib/contexts/FavouriteProductsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSearchBoxProvider","ProductSearchBoxContext"] */ "/workspace/libs/react-helpers/src/lib/contexts/ProductSearchBoxContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useArticles"] */ "/workspace/libs/react-helpers/src/lib/hooks/useArticles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useBrandNames"] */ "/workspace/libs/react-helpers/src/lib/hooks/useBrandNames.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useClientContext","ClientContext"] */ "/workspace/libs/react-helpers/src/lib/hooks/useClientContext.ts");
;
import(/* webpackMode: "eager" */ "/workspace/libs/react-helpers/src/lib/hooks/useCtaColor.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useCurrentProduct"] */ "/workspace/libs/react-helpers/src/lib/hooks/useCurrentProduct.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useProductSearch"] */ "/workspace/libs/react-helpers/src/lib/hooks/useProductSearch.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useProductSearchBox"] */ "/workspace/libs/react-helpers/src/lib/hooks/useProductSearchBox.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTypes"] */ "/workspace/libs/react-helpers/src/lib/hooks/useTypes.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useUrl"] */ "/workspace/libs/react-helpers/src/lib/hooks/useUrl.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem"] */ "/workspace/libs/ui-components/src/lib/AccordionItem.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/AccordionMenu.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/ActonSubmitButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BetterButton"] */ "/workspace/libs/ui-components/src/lib/BetterButton.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/BroadlumeLogo.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/CidImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/libs/ui-components/src/lib/ClientErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/DatePicker.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/FaderCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/FormNotes.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/Gallery.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/GoogleMap.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/MasonryGallery.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/MenuItemBase.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/PrintCouponButton.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/ProductSearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/libs/ui-components/src/lib/RecentProducts.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/SourceInput.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/SwiperLink.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/libs/ui-components/src/lib/TabComponent.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.25_next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d_1dc55041af503e873b61a14c2acdffc2/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.25_next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d_1dc55041af503e873b61a14c2acdffc2/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@next+third-parties@15.5.25_next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d_1dc55041af503e873b61a14c2acdffc2/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d7714ce27126962c7f86a792c4997_3de48f574bd06ade3c03c31b7544dc07/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d7714ce27126962c7f86a792c4997_3de48f574bd06ade3c03c31b7544dc07/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d7714ce27126962c7f86a792c4997_3de48f574bd06ade3c03c31b7544dc07/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d7714ce27126962c7f86a792c4997_3de48f574bd06ade3c03c31b7544dc07/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.25_patch_hash=b773276ac89ba0fcde4f05f8ec9e96cca7d7714ce27126962c7f86a792c4997_3de48f574bd06ade3c03c31b7544dc07/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
